/** Style Notes pointed a scene at a voice. Write's open compose is now stale. */
export const SCENE_VOICE_POINTED = 'scene-voice-pointed';

const STORAGE_PREFIX = 'brainstormy.scene-voice-pointed.';

export function sceneVoicePointKey(storyId) {
  return `${STORAGE_PREFIX}${storyId || ''}`;
}

export function readSceneVoicePoint(storyId) {
  if (!storyId || typeof localStorage === 'undefined') return null;
  try {
    const data = JSON.parse(localStorage.getItem(sceneVoicePointKey(storyId)) || 'null');
    if (!data || !data.sceneId || !Number.isFinite(Number(data.at))) return null;
    return {
      storyId: String(data.storyId || storyId),
      sceneId: String(data.sceneId),
      at: Number(data.at),
    };
  } catch {
    return null;
  }
}

/** True when this scene was pointed after `startedAt` (ms). */
export function sceneVoicePointedAfter(storyId, sceneId, startedAt) {
  const stamp = readSceneVoicePoint(storyId);
  if (!stamp || !sceneId) return false;
  if (stamp.sceneId !== String(sceneId)) return false;
  return stamp.at > Number(startedAt || 0);
}

export function notifySceneVoicePointed(storyId, sceneId) {
  if (typeof window === 'undefined' || !storyId || !sceneId) return;
  const detail = {
    storyId: String(storyId),
    sceneId: String(sceneId),
    at: Date.now(),
  };
  try {
    localStorage.setItem(sceneVoicePointKey(storyId), JSON.stringify(detail));
  } catch {
    /* private mode / quota */
  }
  window.dispatchEvent(new CustomEvent(SCENE_VOICE_POINTED, { detail }));
}
